import { createContext } from 'react';
import { Account } from '../../types/Types';

import AccountHooks from './Account.hooks';

export const AccountContext = createContext({
  accountState: {
    accounts: [{} as Account],
    isLoading: false,
    errMessage: '',
  },
  fetchAccounts: () => {},
  uploadAccounts: (param: []) => {},
  editAccount: (param: Account) => {},
  editManyAccounts: (paramId: string[], param: Account) => {},
  deleteAccount: (paramId: string) => {},
  deleteManyAccounts: (paramId: string[]) => {},
  clear: () => {},
  editStockAgent: (paramId: [], param: Account) => {},
  fetchByStatusAndType: (
    status: string,
    type: string,
    pageSize: number,
    skipAcc: number
  ) => {},
  fetchAccountsByDate: (startDate: Date, endDate: Date) => {},
  searchAccount: (search: string) => {},
  accLength: 0,
});

export function AccountProvider(props: any) {
  const {
    state,
    fetchAccounts,
    uploadAccounts,
    editAccount,
    editManyAccounts,
    deleteAccount,
    deleteManyAccounts,
    clear,
    editStockAgent,
    fetchByStatusAndType,
    fetchAccountsByDate,
    searchAccount,
    accLength,
  } = AccountHooks();

  return (
    <AccountContext.Provider
      value={{
        accountState: state,
        fetchAccounts,
        uploadAccounts,
        editAccount,
        editManyAccounts,
        deleteAccount,
        deleteManyAccounts,
        clear,
        editStockAgent,
        fetchByStatusAndType,
        fetchAccountsByDate,
        searchAccount,
        accLength,
      }}
    >
      {props.children}
    </AccountContext.Provider>
  );
}

//   for (let key in res.data) {
//     getData.push({
//       ...res.data[key],
//       id: key,
//     });
//   }
//   setItems(fetchDatas);
